// extracted by mini-css-extract-plugin
export var textBlock = "text-block-module--text-block--3DjOM";
export var title = "text-block-module--title--46f-N";
export var subtitle = "text-block-module--subtitle--3uV4j";